import React, { useState, useEffect } from "react";
import styles from "./ImageCards.module.css";

const ImageCards = React.memo(function ({
  list = [],
  setCard = () => {},
  containerStyle = "",
}) {
  const defaultState = {
    onLoad: false,
  };
  const [state, setState] = useState({
    ...defaultState,
  });

  const resetState = () => {
    setState({ ...defaultState });
  };
  const addOnLoadClass = () => {
    setState((s) => ({ ...s, onLoad: true }));
  };

  useEffect(() => {
    const callbackId = requestIdleCallback(addOnLoadClass);
    return () => {
      resetState();
      cancelIdleCallback(callbackId);
    };
  }, [list]);
  return (
    <div
      className={
        state.onLoad
          ? `${styles.categoryListAll} ${styles.loaded}`
          : styles.categoryListAll
      }
      style={containerStyle}
    >
      <div className={styles.categoryList}>
        {list.length === 1 && list[0].id === ""
          ? null
          : list.map((content, idx) => (
              <Content
                key={idx}
                id={content.id}
                image={content.image}
                instaRegDate={content.instaRegDate}
                setCard={setCard}
                content={content}
              />
            ))}
      </div>
    </div>
  );
});

export default ImageCards;

const Content = React.memo(
  ({ image = "", instaRegDate = "", content = {}, setCard = () => {} }) => {
    const defaultState = {
      onOff: false,
      isNow: false,
      hasError: false,
    };
    const [state, setState] = useState({
      ...defaultState,
    });
    const setHasError = (flag) => {
      setState((s) => ({ ...s, hasError: flag }));
    };
    const resetState = () => {
      setState({ ...defaultState });
    };
    const click = () => {
      setCard(content);
      setState((s) => ({ ...s, onOff: !s.onOff }));
    };
    const imageStyle = {
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
    };

    useEffect(() => {
      return () => {
        resetState();
      };
    }, []);
    return (
      <div className={styles.categoryContainer} onClick={click}>
        <div className={styles.categoryArea}>
          <div className={styles.categoryImage} style={imageStyle}>
            {!state.hasError ? (
              <img
                className={styles.categoryImage}
                src={image}
                onError={() => {
                  setHasError(true);
                }}
              />
            ) : (
              <div className={styles.notFoundContainer}>
                <pre
                  className={styles.notFound}
                >{`not found\nid: ${content.id}`}</pre>
              </div>
            )}
            {state.onOff && (
              <div className={styles.listItemDisabled}>
                <div className={styles.checkIcon} />
              </div>
            )}
          </div>
        </div>
        <div className={styles.titleDescriptionArea}>
          <div className={styles.title2}>
            <span className={styles.babyFood}>*인스타 등록일</span>
            <span className={styles.babyFood}>: {instaRegDate}</span>
          </div>
        </div>
      </div>
    );
  }
);
